export default "__VITE_ASSET__012ff21b__"